module.exports = __webpack_public_path__ + "static/media/pickleweed.312e1a9b.jpg";